/**
 * is object empty
 * @param  {Object}  obj
 * @return {boolean}
 */
__.isObjectEmpty = function(obj) {
  return __.isObject(obj) && Object.keys(obj).length === 0;
};
